import React, { useState } from 'react';
import { inject } from '@app/providers/QAU.ContextProvider';
import classnames from 'classnames';
import PropTypes from 'prop-types';

const STATIC_PATH = '/dpp-static-content';
const DEFAULT_CONTENT_PATH = '/help/qau';
const DEFAULT_LOCALE = 'en-US';

const LocalizedImage = ({
  flowConfig,
  name,
  alt,
  bordered = false,
  allowDefault = false,
  contentPath = DEFAULT_CONTENT_PATH,
  width,
  height,
}) => {
  const locale = flowConfig.locale.name;
  const resources = flowConfig.getResourceURL('dpo8-static-content');
  const baseUrl = resources + STATIC_PATH + contentPath;
  const imagePath = `${baseUrl}/${locale}/${name}`;
  const [imageSrc, setImageSrc] = useState(imagePath);
  const [isHidden, setIsHidden] = useState(false);


  const onImageError = () => {
    allowDefault
      ? setImageSrc(`${baseUrl}/${DEFAULT_LOCALE}/${name}`)
      : setIsHidden(true);
  }

  return <img
    className={classnames({bordered})}
    alt={alt}
    src={imageSrc}
    onError={onImageError}
    width={width}
    height={height}
    hidden={isHidden}
  />
}

LocalizedImage.propTypes = {
  name: PropTypes.string.isRequired,
  alt: PropTypes.string.isRequired,
  contentPath: PropTypes.string,
  bordered: PropTypes.bool,
  width: PropTypes.number,
  height: PropTypes.number,
  flowConfig: PropTypes.object.isRequired,
  allowDefault: PropTypes.bool,
};

export default inject('flowConfig')(LocalizedImage);